module.exports = new __parcel__URL__("linea.cd3a1e8c.svg").toString();